module.exports = __webpack_public_path__ + "img/電気回路_6_1_5.506c970b.png";